import styled, { css } from 'styled-components';

export const Page = styled.main(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 100vh;
    width: 100%;

    @media (max-width: ${theme.sz.lg}) {
      grid-template-columns: 1fr;
      min-height: auto;
    }
  `,
);

export const MobileContent = styled.div(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: block;
      padding: 0 ${theme.sz.s5} ${theme.sz.s28};
    }
  `,
);
